import { createFileRoute, redirect } from '@tanstack/react-router';
import { RegisterGuest } from '../../pages/RegisterGuest';
import { userProfileKeys } from '@/lib/hooks/useUserProfile';
import * as userProfilesService from '@/lib/services/userProfiles';
import type { UserRole } from '@/lib/types/database';

export const Route = createFileRoute('/_authenticated/register-guest')({
  beforeLoad: async ({ context }) => {
    // User must be authenticated (already checked by _authenticated route)
    if (!context.auth.isAuthenticated || !context.auth.user) {
      throw redirect({ to: '/login' });
    }

    const userId = context.auth.user.id;

    // Fetch user profile to check role
    try {
      const profile = await context.queryClient.ensureQueryData({
        queryKey: userProfileKeys.current(userId),
        queryFn: () => userProfilesService.getUserProfile(userId),
      });
      const userRole = profile?.role as UserRole | null;

      // Only Fellows and Admins can register guests
      if (!userRole || (userRole !== 'fellow' && userRole !== 'admin')) {
        throw redirect({
          to: '/',
          search: {
            // Optional: Add a message parameter to show why they were redirected
            message: 'Only Fellows and Admins can register guests',
          },
        });
      }
    } catch (error) {
      // If profile fetch fails or user doesn't have required role, redirect to home
      if (error instanceof redirect) {
        throw error;
      }
      // On other errors, redirect to home
      throw redirect({ to: '/' });
    }
  },
  component: RegisterGuestPage,
});

function RegisterGuestPage() {
  return <RegisterGuest />;
}
